<template>
  <div>
    <modal id="limit-reached-modal" ref="modalWrapper" :hide-backdrop="!isOwner" :no-close-on-esc="!isOwner" @shown="allowInteraction" :no-close-on-backdrop="!isOwner" :hide-footer="true" :hide-header="true" centered>
      <h5>{{this.title}}</h5>
      <div id="hidden-icon" v-html="require('!html-loader!images/icons-hidden.svg')" />
      <p>{{this.body}}</p>
      <a v-if="isOwner" id="upgrade-to-unlock" data-testid="upgrade-to-unlock" href="/plans?utm_source=viewer&utm_campaign=10-views-limit" class="btn">Upgrade to unlock</a>
      <span id="already-upgraded" v-if="isOwner">Already upgraded? contact <a href="mailto:support@getcloudapp.com">support@getcloudapp.com</a></span>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    isOwner: {
      type: Boolean, required: true
    }
  },
  mounted() {
    if(this.viewLimitReached){
      this.$refs.modalWrapper.$refs.modal.show()
    }
  },
  methods: {
    allowInteraction: function(){
      // Vue bootstrap makes it really hard to customize stuff like this, doesn't seem like they care.
      // https://github.com/bootstrap-vue/bootstrap-vue/issues/4886
      if(!this.isOwner){ $("#limit-reached-modal___BV_modal_outer_").css("z-index", 0); }
    },
  },
  computed: {
    ...mapState({
      viewLimitReached: state => state.item.attributes.view_limit_reached
    }),
    title: function(){
      return this.isOwner ? "View Limit Reached" : "This item has exceeded its view limit!"
    },
    body: function(){
      return this.isOwner ? "Upgrade now to remove view limit and unlock unlimited views." : "The item owner has been notified that their item has exceeded its view limit."
    }
  }
}
</script>

<style lang="scss" scoped>
  #limit-reached-modal___BV_modal_outer_.no-owner {
    // allow user menu to be used when is not dismissable
    z-index: 0;
  }

  #upgrade-to-unlock{
    background: rgb(246,148,19);
    background: linear-gradient(90deg, rgba(246,148,19,1) 20%, rgba(241,77,87,1) 85%);
    color: white;
  }

  #hidden-icon {
    border: 8px solid #2D2D2D;
    border-radius: 4px;
    padding: 15px;
    display: inline-flex;
  }

  #already-upgraded {
    font-size: .7rem;
    margin-top: 10px;
  }

</style>

<style lang="scss">
  // Vue deep selectors don't go well with slots which we use for <modal> component
  // need to style this way.
  #limit-reached-modal___BV_modal_outer_ {
    .modal-content {
      padding: 30px 0;
      align-items: center;
    }

    .modal-dialog {
      width: 24rem;
    }

    .modal-body {
      padding: 0;
      align-items: center;
      display: flex;
      flex-direction: column;
      text-align: center;

      p {
        margin-top: 1rem;
        width: 17rem;
      }
    }

    #hidden-icon {
      svg {
        width: 100px;
        height: 100px;

        g path {
          fill: #2D2D2D;
        }
      }
    }
  }
</style>